import { z } from "zod/v4";

import { IntelligemsRoleList } from "../schemas/intelligems";

export const RoleDtoSchema = z.object({
  id: z.uuid(),
  userId: z.uuid(),
  organizationId: z.uuid(),
  roleType: z.enum(IntelligemsRoleList),
  lastLoginTs: z.number().nullish(),
});

export type RoleDto = z.infer<typeof RoleDtoSchema>;
